import { cva } from "class-variance-authority"

export const menuItem = cva(
	[
		"select-none",
		"relative",
		"flex",
		"items-center",
		"rounded",
		"outline-none",
		"data-[disabled=true]:text-(--base-a8)",
		"shrink-0",
	],
	{
		variants: {
			size: {
				xs: ["h-6", "gap-1.5", "px-3"],
				sm: ["h-7", "gap-1.75", "px-3.5"],
				md: ["h-8", "gap-2", "px-4"],
				lg: ["h-9", "gap-2.25", "px-4.5"],
				xl: ["h-10", "gap-2.5", "px-5"],
			},
			variant: {
				solid: [
					"text-(--base-12)",
					"data-active:not-data-[disabled=true]:text-(--accent-contrast)",
					"data-active:not-data-[disabled=true]:bg-(--accent-a9)",
					"data-active:not-data-[disabled=true]:active:brightness-110",
				],
				soft: [
					"text-(--base-12)",
					"data-active:not-data-[disabled=true]:bg-(--accent-a3)",
					"data-active:not-data-[disabled=true]:active:bg-(--accent-a4)",
				],
			},
		},
		defaultVariants: {
			size: "md",
			variant: "soft",
		},
	},
)

export const menuLabelCva = cva(["text-(--base-a10)", "flex", "items-center", "select-none"], {
	variants: {
		size: {
			xs: ["h-6", "gap-1.5", "px-3", "text-xs"],
			sm: ["h-7", "gap-1.75", "px-3.5", "text-xs"],
			md: ["h-8", "gap-2", "px-4", "text-sm"],
			lg: ["h-9", "gap-2.25", "px-4.5", "text-base"],
			xl: ["h-10", "gap-2.5", "px-5", "text-lg"],
		},
	},
	defaultVariants: {
		size: "md",
	},
})

export const menuSeparator = cva(["h-px", "bg-(--base-a6)", "w-auto", "shrink-0"], {
	variants: {
		size: {
			xs: ["-mx-0.5", "my-0.5"],
			sm: ["-mx-0.75", "my-0.75"],
			md: ["-mx-1", "my-1"],
			lg: ["-mx-1.25", "my-1.25"],
			xl: ["-mx-1.5", "my-1.5"],
		},
	},
	defaultVariants: {
		size: "md",
	},
})

export const menuContent = cva(
	[
		"flex",
		"flex-col",
		"w-max",
		"max-w-xs",
		"outline-none",
		"pointer-events-auto",
		"bg-(--color-background)",
		"dark:bg-(--base-2)",
		"ring-1",
		"ring-(--base-6)",
		"overflow-hidden",
	],
	{
		variants: {
			size: {
				xs: ["p-0.5", "text-xs", "min-w-30"],
				sm: ["p-0.75", "text-sm", "min-w-35"],
				md: ["p-1", "text-md", "min-w-40"],
				lg: ["p-1.25", "text-lg", "min-w-45"],
				xl: ["p-1.5", "text-xl", "min-w-50"],
			},
		},
		defaultVariants: {
			size: "md",
		},
	},
)
